import { subdomains } from "@/common/consts";
import ESLHome from "@/pages/ESL/Home/ESLHome.vue";
import ESLDetail from "@/pages/ESL/Detail/ESLDetail.vue";
import ExperimentOverride from "@/pages/ExperimentOverride/ExperimentOverride.vue";

export default [
    {
        path: "/",
        name: "ESLHome",
        meta: {
            subdomain: subdomains.ESL
        },
        component: ESLHome
    },
    {
        path: "/abexp/:channel?",
        name: "ExperimentOverride",
        component: ExperimentOverride
    },
    {
        path: "/*",
        name: "ESLDetail",
        meta: {
            subdomain: subdomains.ESL
        },
        component: ESLDetail
    }
];



// WEBPACK FOOTER //
// ./src/router/routes/subdomain.esl.js